import { CmsSiteKey } from '@prisma-clinic/client'

import { api } from '../core/trpc'
import { CmsNavLink } from './useCmsSiteHeader'
import { useLocale } from './useLocale'

/**
 * Every published cms page, for the "Pages" menu in the header.
 *
 * This is the automatic half of the site navigation: an editor publishes a page and it becomes
 * reachable, with no second step in `/cms/chrome`. The curated header menu is still the way to
 * promote a page to the top level or to give it a different label and position — see
 * `useCmsSiteHeader`.
 *
 * Paths arrive already canonical from the server, which is also what applies the locale fallback,
 * so an untranslated page keeps its link rather than disappearing for English visitors.
 */
export const useCmsPagesMenu = (): CmsNavLink[] => {
    const { locale } = useLocale()
    const { data } = api.cmsPage.getNavigationPages.useQuery({ siteKey: CmsSiteKey.LONGY, locale })

    return (data ?? []).map((page) => ({ href: page.path, label: page.title }))
}
